import { useTranslation } from "react-i18next";
import { changeLocale, resolveLocale, type Locale } from "../i18n";

const options: ReadonlyArray<{ locale: Locale; label: string }> = [
  { locale: "en", label: "EN" },
  { locale: "zh-CN", label: "中文" }
];

export function LanguageSwitcher() {
  const { t, i18n } = useTranslation();
  const activeLocale = resolveLocale(i18n.resolvedLanguage ?? i18n.language);

  return (
    <div className="language-switcher segmented" role="group" aria-label={t("common.language.label")}>
      {options.map(({ locale, label }) => (
        <button
          key={locale}
          type="button"
          className="language-switcher-option segment"
          data-locale={locale}
          aria-label={t(locale === "en" ? "common.language.english" : "common.language.chinese")}
          aria-pressed={activeLocale === locale}
          onClick={() => void changeLocale(locale)}
        >
          <span lang={locale}>{label}</span>
        </button>
      ))}
    </div>
  );
}
